/**
 * Console-only structured logger (no Sentry in Go).
 *
 * debug/info are silent in production builds; warn/error always emit.
 */

const isDev = import.meta.env.DEV;

export function createLogger(scope: string) {
  const prefix = `[${scope}]`;

  return {
    /** Debug-level: only visible in development */
    debug(...args: unknown[]) {
      if (isDev) console.debug(prefix, ...args);
    },

    /** Info-level: only visible in development */
    info(...args: unknown[]) {
      if (isDev) console.log(prefix, ...args);
    },

    /** Warning: always visible */
    warn(...args: unknown[]) {
      console.warn(prefix, ...args);
    },

    /** Error: always visible */
    error(...args: unknown[]) {
      console.error(prefix, ...args);
    },
  };
}

/** General-purpose app logger */
export const log = createLogger('Go');
